let header = document.querySelector(".header");
let headerBtn = document.querySelector(".header__innerBlockTopBtnsMenu");

headerBtn.addEventListener("click", () => {
    header.classList.toggle("is-on");
    noscroll(header.classList.contains("is-on"));
});

export function noscroll(bool) {
    if (bool) {
        document.body.style.overflow = "hidden";
    } else {
        document.body.style.overflow = "";
    }
}

function disableScroll(event) {
    event.preventDefault();
}

// 対象の要素を取得
const element = document.querySelector(".header__bottom");
const hovermenus = document.querySelector(".header__hovermenus");

// 前回のスクロール位置を保持する変数
let lastScrollY = 0;

// スクロールイベントリスナーを追加
window.addEventListener("scroll", () => {
    // 現在のスクロール位置を取得
    const currentScrollY = window.scrollY;

    // スクロールが一番上にあるか、上方向にスクロールしている場合
    if (currentScrollY === 0 || currentScrollY < lastScrollY) {
        element.classList.remove("is-hidden");
        hovermenus.classList.remove("hb-is-hidden");
    } else {
        // 下方向にスクロールしている場合
        element.classList.add("is-hidden");
        hovermenus.classList.add("hb-is-hidden");
    }

    // 現在のスクロール位置を保存
    lastScrollY = currentScrollY;
});
